import React, { ReactNode } from 'react'

const Item = (props: { href?: string; children: ReactNode; target?: string }) => {
  const { href, children, target = '_blank' } = props
  return (
    <li>
      {href ? (
        <a href={href} target={target} rel='noreferrer'>
          {children}
        </a>
      ) : (
        children
      )}
    </li>
  )
}

export default Item
